/** Home, the staff landing page that lists every leychoon.app app. */
export const HOME_URL = "https://www.leychoon.app";
